import { ChainId } from 'types/chains';
export const LABEL_MAPPING = [
    {
        id: 4,
        label: 'Bitcoin (Testnet 3)',
    },
    {
        id: ChainId.MerlinTestnet,
        label: 'Merlin (Testnet)',
    },
    {
        id: ChainId.Sepolia,
        label: 'Ethereum (Sepolia Testnet)',
    },
    {
        id: ChainId.EthereumHolesky,
        label: 'Ethereum (Holesky Testnet)',
    },
    {
        id: ChainId.BaseSepolia,
        label: 'Base (Sepolia Testnet)',
    },
    {
        id: ChainId.ModeSepolia,
        label: 'Mode (Sepolia Testnet)',
    },
];
